"use client"

import { ComponentConfig, DropZone } from "@measured/puck"
import "swiper/css"
import "swiper/css/pagination"
import { twMerge } from "tailwind-merge"
import { configs } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"
export interface CustomToursProps extends CommonStylesProps {
  logoStyles?: {
    width: string
    height: string
    padding: string
    margin: string
    objectFit: "cover" | "contain" | "fill" | "none" | "scale-down"
  }
  type: "fluid" | "custom" | "boxed"
  heightCustomTour?: string
  gapCustom?: string
  bgImage?: string
  iconImage?: string
  titleText?: string
  contentText?: string
}

export const RenderConfig: ComponentConfig<CustomToursProps> = {
  render: ({
    logoStyles = {},
    className,
    type,
    styles,
    gapCustom,
    responsiveType,
    heightCustomTour,
    bgImage,
    iconImage,
    titleText,
    contentText,
  }) => {
    const id = `navigation-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div
          id={id}
          className={twMerge(
            className,
            "relative w-full flex flex-col lg:h-[400px] h-[478px] items-center justify-center lg:bg-cover bg-cover bg-center lg:rounded-2xl",
          )}
          style={{
            backgroundImage: `url(${configs.API_URL}${bgImage})`,
          }}
        >
          <div className="absolute inset-0 bg-[#00000080] lg:rounded-2xl" />
          <div className="relative z-10 flex flex-col items-center gap-6 max-w-[469px]">
            <div className="flex lg:flex-row sm:flex-col items-center gap-4">
              {iconImage && (
                <img
                  src={`${configs.API_URL}${iconImage}`}
                  alt="Icon"
                  style={{ objectFit: "contain", width: "64px", height: "64px", opacity: "80%" }}
                />
              )}
              {titleText && (
                <h1 className="lg:text-5xl sm:text-[40px] font-bold text-white" style={{ lineHeight: "56px" }}>
                  {titleText}
                </h1>
              )}
            </div>
            {contentText && (
              <p className="lg:mt-4 sm:mt-6 text-center text-white text-lg" style={{ lineHeight: "22px" }}>
                {contentText}
              </p>
            )}
            <div className="mt-6 w-full flex items-center justify-center">
              <DropZone zone="Button" />
            </div>
          </div>
        </div>
      </>
    )
  },
}
